//QA
let baseURL = "http://52.230.119.123:3029/";

// let baseURL = "https://dev.rahper.com/";
// let baseURL = "http://20.212.227.60:3014";

export { baseURL };
